require("../modules/es.weak-map.constructor");

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVzLndlYWstbWFwLmpzIl0sIm5hbWVzIjpbInJlcXVpcmUiXSwibWFwcGluZ3MiOiJBQUNBQSxRQUFRIiwiZmlsZSI6Ii9idWlsZHMveW9jby95b2NvLWFkbWluL25vZGVfbW9kdWxlcy9jb3JlLWpzL21vZHVsZXMvZXMud2Vhay1tYXAuanMifQ==